/**
 * Calculates the physical size of the string.
 * This function does not do its job perfectly, maybe wrap the rect and the text into a group?
 * 
 * @author Teemu Salonen <teemu.salonen@kvanttori.fi>
 */

const calculateNameSize = (name: string) => {
    
    // Logic for the following strings:
    // Similar (approximated) values of sizes by width in pixels
    let length = 0;
    const capitals = "ABCDEFGHJKLMNOPQRSTUVWXYZ/()";
    const letters = "Iabcdefghjkmnopqrstuvwxyz0123456789";
    const smallOnes = "il ";

    for(let i = 0; i < name.length; i++) {
      if(capitals.includes(name.charAt(i))){
        length += 1.5;
      } else if(letters.includes(name.charAt(i))) {
        length += 1;
      } else if(smallOnes.includes(name.charAt(i))){
        length += 0.85;
      } else {
        length += 2;
      }
    }

    return length;
};

export default calculateNameSize;